import { render, staticRenderFns } from "./TagsTrucks.vue?vue&type=template&id=7e89e5cc&scoped=true"
import script from "./TagsTrucks.vue?vue&type=script&lang=js"
export * from "./TagsTrucks.vue?vue&type=script&lang=js"
import style0 from "./TagsTrucks.vue?vue&type=style&index=0&id=7e89e5cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e89e5cc",
  null
  
)

export default component.exports